/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Geometry as o}from"./Geometry.js";class t extends o{}function e(o){return null!=o.mapPositions}export{t as GeometryWithMapPositions,e as isGeometryWithMapPositions};
